import React from 'react';
import styled from 'styled-components';

const TelWrapper = styled.div`
  max-width: 870px;
  text-align: right;
  margin: 48px auto 0 auto;
  width: ${({ pageId })=>{
    return pageId==='plan'?'100%':'90%'}};
  & > .context {
    text-align: right;
    font-size: 18px;
    color:inherit;
  }
  & > .tel {
    text-align: right;
    font-weight: 900;
    font-size: 18px;
    color:inherit;
    &:focus {
      outline: 0;
      border: 4px solid #00524D;
      border-radius: 4px;
    }
  }
  & > hr{
    margin:8px 0px;
  }
 

`;

const HiddenText = styled.span`
  display: none;
`;

const FooterTelephone = ({ custCareTel,pageId }) => {
  return (
    <TelWrapper pageId={ pageId }>
      <span className="context" id="footer-telephone">Call to speak to a Life Representative</span><br />
      <HiddenText id="description">
        {custCareTel}
      </HiddenText>
      <a className="tel" href={ `tel:${custCareTel}` } aria-labelledby="footer-telephone description">
        {custCareTel}
      </a>
      <hr/>
    </TelWrapper>
  );
};

export default FooterTelephone;
